export var selectMessageTheme = {
  baseStyle: _ref => {
    var {
      onClick
    } = _ref;
    return {
      container: {
        display: 'flex',
        position: 'relative',
        justifyContent: onClick ? 'flex-start' : 'center',
        color: onClick ? 'brand.main' : 'neutral.darker',
        transition: 'color 0.3s ease',
        _hover: {
          color: onClick ? 'brand.dark' : 'neutral.darker'
        }
      }
    };
  }
};
//# sourceMappingURL=SelectMessage.theme.js.map